import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthInterceptor } from "./AuthInterceptor";
import VersionInterceptor from "@/api/VersionInterceptor";
import { Logger } from "@iloq/shared";
import {
  IProductData,
  IProductCategory,
  IActiveProductSearchQuery,
  IProductSearchQuery,
  IPartnerProductSearchResult,
  IProductSearchResult,
  IServiceproductMap,
} from "@iloq/shared";

export default class ProductSearchApi {
  private readonly axios: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    AuthInterceptor.setAuthInterceptors(this.axios);
    VersionInterceptor.setVersionInterceptor(this.axios);
  }

  searchActivePartnerProducts(
    query: IActiveProductSearchQuery
  ): Promise<IPartnerProductSearchResult> {
    Logger.debug(`Searching for active partner products with query= ${JSON.stringify(query)}`);

    const options: AxiosRequestConfig = {
      method: "POST",
      url: "/api/v1/products/product/search-active",
      data: query,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("ProductSearchApi.searchActivePartnerProducts failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("ProductSearchApi.searchActivePartnerProducts result:", result);
        return result.data as IPartnerProductSearchResult;
      });
  }

  fetchProduct(sku: string): Promise<IProductData> {
    Logger.debug(`Fetching product with sku ${sku}`);

    const options: AxiosRequestConfig = {
      method: "GET",
      url: `/api/v1/products/product/${sku}`,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("ProductSearchApi.fetchProduct failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("ProductSearchApi.fetchProduct result:", result);
        return result.data as IProductData;
      });
  }

  getServiceproducts(priceListAreaCode: string): Promise<IServiceproductMap> {
    Logger.debug(`Fetching serviceproducts with priceListAreaCode: ${priceListAreaCode}`);

    const options: AxiosRequestConfig = {
      method: "GET",
      url: `/api/v1/products/serviceproducts/${priceListAreaCode}`,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("ProductSearchApi.getServiceproducts failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("ProductSearchApi.getServiceproducts result:", result);
        return result.data;
      });
  }

  fetchCategoryTree(): Promise<IProductCategory> {
    Logger.debug("Fetching category tree");

    const options: AxiosRequestConfig = {
      method: "GET",
      url: "/api/v1/products/categories",
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("ProductSearchApi.fetchCategoryTree failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("ProductSearchApi.fetchCategoryTree result:", result);
        return result.data as IProductCategory;
      });
  }

  searchProducts(query: IProductSearchQuery): Promise<IProductSearchResult> {
    Logger.debug(`Searching for all products with query= ${JSON.stringify(query)}`);

    const options: AxiosRequestConfig = {
      method: "POST",
      url: "/api/v1/products/product/search",
      data: query,
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("ProductSearchApi.searchProducts failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("ProductSearchApi.searchProducts result:", result);
        return result.data as IProductSearchResult;
      });
  }
}
